/* global Foundation */

function debounce (func, wait) {
  let timeout
  return function (...args) {
    const context = this
    clearTimeout(timeout)
    timeout = setTimeout(() => func.apply(context, args), wait)
  }
}

const csrfProtection = (xhr) => {
  const token = document.querySelector('meta[name="csrf-token"]')?.content
  if (token != null) {
    return xhr.setRequestHeader('X-CSRF-Token', token)
  }
}

$(document).ready(() => {
  if (window.location.hash === '#set-password') {
    const $modalDiv = $('#set-password')
    if ($modalDiv.length > 0) {
      const $modal = new Foundation.Reveal($modalDiv)
      $modal.open()
    }
  }

  const $container = $('#new-review-form-container')
  const reviewId = $container.data('reviewId')

  // duplicate chrome tab caused the last ajax call to be loaded instead of the html view
  $container.on('click', '.go-back', (e) => {
    e.preventDefault()
    $.ajax(`/reviews/${reviewId}/edit.js`)
  })

  $container.on('keyup', '#review-body', debounce((e) => {
    microUpdate(e.currentTarget.name, e.currentTarget.value)
  }, 5000))

  $container.on('change', '#review_contract_vehicle_id', debounce((e) => {
    microUpdate(e.currentTarget.name, e.currentTarget.value)
  }, 3000))

  $container.on('change', '#review_contract_id', debounce((e) => {
    microUpdate(e.currentTarget.name, e.currentTarget.value)
  }, 3000))

  $container.on('change', '#review_contract_freeform', debounce((e) => {
    microUpdate(e.currentTarget.name, e.currentTarget.value)
  }, 3000))

  $container.on('change', '.reviewer-display-input, .share-with-supplier-input', (e) => {
    const el = e.currentTarget
    let value = null

    if (el.checked) {
      value = el.value
    } else {
      value = $(`input[name="${e.currentTarget.name}"][type="hidden"]`).val()
    }

    microUpdate(e.currentTarget.name, value)
  })

  $container.on('change', '.nps-input, .star-input', (e) => {
    microUpdate(e.currentTarget.name, e.currentTarget.value)
  })

  $container.on('click', '#save-body-button', (e) => {
    e.preventDefault()

    const form = $(e.currentTarget).closest('form')
    const updatedBody = form.find('#review-body-page-2').val()
    const submitButton = form.find('#save-body-button')

    $.ajax({
      url: form.attr('action'),
      method: form.attr('method'),
      data: { review: { body: updatedBody } },
      beforeSend: csrfProtection,
      success: () => {
        microUpdate('review[body]', updatedBody)
        submitButton.val('THANK YOU')
      },
      error: (error) => {
        console.error('Error updating review body:', error)
      }
    })
  })

  $container.on('input', '#review-body-page-2', () => {
    const submitButton = $('#save-body-button')
    submitButton.val('SUBMIT REVIEW')
  })

  const microUpdate = (name, value) => {
    const page = $('#review-form-inner-container').data('page')
    const reviewStatus = $('#review-form-inner-container').data('reviewStatus')

    // do not autosave on page 1 when the review has been published
    if (page === 1 && reviewStatus === 'published') {
      return
    }

    $('#save-confirmation').css({ opacity: 0 })

    const data = {}
    data[name] = value

    $.ajax({
      url: `/reviews/${reviewId}/micro_update`,
      method: 'PATCH',
      data,
      beforeSend: csrfProtection
    }).then(() => {
      const text = saveConfirmationText(name)
      const $saveConfirmation = $('#save-confirmation')
      const $confirmationMessage = $('#save-confirmation-message')

      if (text !== '') {
        $confirmationMessage.text(text)
        $saveConfirmation.addClass('show-checkmark')
        $saveConfirmation.animate({ opacity: 1 }, 800)
      } else {
        $saveConfirmation.removeClass('show-checkmark')
        $confirmationMessage.empty()
        $saveConfirmation.animate({ opacity: 0 }, 800)
      }
    })
  }
})

const showReviewCta = () => {
  setTimeout(() => {
    $('#review-cta-container, #view-supplier-profile').addClass('fade-in')
  }, 1000)
}

if (window.app === undefined) {
  window.app = {}
}
window.app.showReviewCta = showReviewCta

const saveConfirmationText = (field) => {
  let text = ''
  const submitButtonClicked = $('#save-body-button').is(':focus')

  switch (field) {
    case 'review[net_promoter]':
      text = 'Your recommendation has been captured'
      break
    case 'review[service_rating]':
      text = 'Your customer service rating has been captured'
      break
    case 'review[price_rating]':
      text = 'Your pricing/value rating has been captured'
      break
    case 'review[quality_rating]':
      text = 'Your quality rating has been captured'
      break
    case 'review[timeliness_rating]':
      text = 'Your timeliness rating has been captured'
      break
    case 'review[body]':
      if (submitButtonClicked) {
        text = 'Your review has been captured'
      }
      break
  }

  return text
}
